import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { GET } from '../consts/Methods';
import { SET_LOADER } from '../redux/Loader';
import { FETCH_PROMOTION, FETCH_PROMOTION_FAIL, FETCH_PROMOTION_SUCCESS } from '../redux/Promotions';

function* FetchPromotionFlow({ payload, }) {
  try {
    const endpoint = `${apiRoot}/promotions/${payload}`;
    yield put(SET_LOADER({ value: true, }));
    const response = yield call(apiCall, { method: GET, endpoint, });
    yield put(FETCH_PROMOTION_SUCCESS(response));
  } catch (error) {
    yield put(FETCH_PROMOTION_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* FetchPromotion() {
  yield takeLatest(FETCH_PROMOTION, FetchPromotionFlow);
}
